module.exports = __webpack_public_path__ + "static/media/profile_comparation_rect.54273922.jpg";